import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const isSideBarContractedStateSlice = createSlice({
	name: 'isSideBarContractedState',
	initialState,
	reducers: {
		setIsSideBarContractedState: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		},
		revertIsSideBarContractedState: (state) => {
			return !state;
		}
	}
});

export const { setIsSideBarContractedState, revertIsSideBarContractedState } = isSideBarContractedStateSlice.actions;

export default isSideBarContractedStateSlice.reducer;
